import type { DashboardVisibility } from "@/types/dashboard";
import { Icon } from "@uigovpe/components";
import { useState } from "react";
import PerformanceMetricCard from "./PerformanceMetricCard";
import ProfileViewsDialog from "./dialogs/ProfileViewsDialog";
import ProductViewsDialog from "./dialogs/ProductViewsDialog";
import WhatsappClicksDialog from "./dialogs/WhatsappClicksDialog";

type Props = { visibility?: DashboardVisibility };

function variationTooltip(variation?: number | null) {
  if (variation === null || variation === undefined)
    return "Comparação indisponível para o período anterior";
  if (variation === 0) return "Sem variação em relação ao período anterior";
  const formatted = Math.abs(variation).toLocaleString("pt-BR", {
    maximumFractionDigits: 1,
  });
  return `${variation > 0 ? "↑" : "↓"} ${formatted}% em relação ao período anterior`;
}

export default function ShowcasePerformance({ visibility }: Props) {
  const [profileViewsOpen, setProfileViewsOpen] = useState(false);
  const [productViewsOpen, setProductViewsOpen] = useState(false);
  const [whatsappClicksOpen, setWhatsappClicksOpen] = useState(false);

  return (
    <article className="flex! h-full! min-h-[280px]! flex-col! justify-center! rounded-2xl! bg-white! p-6! shadow-xl!">
      <div className="mb-5! flex! items-center! gap-2!">
        <Icon
          icon="analytics"
          outline
          className="text-[18px]! text-[#4e3873]!"
        />
        <h3 className="m-0! text-[16px]! font-bold! text-[#494c57]!">
          Desempenho da vitrine
        </h3>
      </div>
      <p className="mt-0! mb-5! text-[12px]! text-[#494c57]!">
        Veja como as pessoas estão interagindo com seu perfil e produto
      </p>
      <div className="grid! grid-cols-3! gap-3! max-sm:grid-cols-1!">
        <PerformanceMetricCard
          id="profile-views-metric"
          icon="person"
          label="Visualização de perfil"
          value={visibility?.visualizacoesPerfil.total ?? 0}
          tooltip={variationTooltip(
            visibility?.visualizacoesPerfil.variacaoPercentual,
          )}
          onClick={() => setProfileViewsOpen(true)}
        />
        <PerformanceMetricCard
          id="product-views-metric"
          icon="shopping_bag"
          label="Visualização de produto"
          value={visibility?.visualizacoesProdutos.total ?? 0}
          tooltip={variationTooltip(
            visibility?.visualizacoesProdutos.variacaoPercentual,
          )}
          onClick={() => setProductViewsOpen(true)}
        />
        <PerformanceMetricCard
          id="whatsapp-clicks-metric"
          icon="call"
          label="Cliques no WhatsApp"
          value={visibility?.cliquesWhatsapp.total ?? 0}
          tooltip={variationTooltip(
            visibility?.cliquesWhatsapp.variacaoPercentual,
          )}
          onClick={() => setWhatsappClicksOpen(true)}
        />
      </div>
      <a
        href="#visibilidade"
        className="mt-5! flex! items-center! gap-1! text-[12px]! font-medium! text-[#4e3873]! no-underline!"
      >
        Visualizar análise detalhada
        <Icon icon="arrow_right_alt" outline className="text-[16px]!" />
      </a>
      <ProfileViewsDialog
        visible={profileViewsOpen}
        onHide={() => setProfileViewsOpen(false)}
      />
      <ProductViewsDialog
        visible={productViewsOpen}
        onHide={() => setProductViewsOpen(false)}
      />
      <WhatsappClicksDialog
        visible={whatsappClicksOpen}
        onHide={() => setWhatsappClicksOpen(false)}
      />
    </article>
  );
}
